import React from 'react';

interface NotificationsShellProps {
  children: React.ReactNode;
  isDarkMode?: boolean;
}

const NotificationsShell: React.FC<NotificationsShellProps> = ({ children }) => {
  return <>{children}</>;
};

export default NotificationsShell;
